var chunkMapping = {
	"247": [
		40247
	],
	"3886": [
		45124
	],
	"5908": [
		54659
	],
	"6031": [
		36983
	]
};
var idToExternalAndNameMapping = {
	"36983": [
		"default",
		"./orderRedux",
		98412
	],
	"40247": [
		"default",
		"./OrderSubtypeSelector",
		98412
	],
	"45124": [
		"default",
		"./orderRemoteReducer",
		98412
	],
	"54659": [
		"default",
		"./OrderApp",
		98412
	]
};
var idToRemoteMap = {
	"36983": [
		{
			"externalType": "script",
			"name": "corksyOrders",
			"externalModuleId": 98412
		}
	],
	"40247": [
		{
			"externalType": "script",
			"name": "corksyOrders",
			"externalModuleId": 98412
		}
	],
	"45124": [
		{
			"externalType": "script",
			"name": "corksyOrders",
			"externalModuleId": 98412
		}
	],
	"54659": [
		{
			"externalType": "script",
			"name": "corksyOrders",
			"externalModuleId": 98412
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}